import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {stepEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import {CSSTransition} from 'react-transition-group';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const DebtPaymentStart = (props) => {
  const [mount, setMount] = useState(false);
  const [render, setRender] = useState(true);

  let mainImg = require('../images/icons-click.svg');
  useEffect(() => {
    if (props.currentStep === stepEnum.START) {
      setRender(true);
      setMount(true);
      gaEvent(gaParams.DEBT_PAYMENT_START.category, gaParams.DEBT_PAYMENT_START.eventType, gaParams.DEBT_PAYMENT_START.eventParams);
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  return (
    <CSSTransition key={0} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className={'debtpayment-step'}>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='משלמים את החוב בכרטיס אשראי' classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='debtpayment-step-subtitle justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='זה קל, בטוח ומהיר במיוחד' />
          </Col>
        </Row>
        <Row className='justify-content-md-center main-img'>
          <Col md='auto'>
            <BasicImage src={mainImg} />
          </Col>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit isBusiness formid='' text='אוקי, נתחיל' onclick={() => props.onclick()} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default DebtPaymentStart;
